import { __ } from '@wordpress/i18n'

export default {
  notFound: __('No Manufacturer', 'dhsv_theme'),
  buttonTitle: __('Mehr erfahren', 'dhsv_theme'),
  buttonTitleIT: __('Scopri la soluzione', 'dhsv_theme'),
}
